// import 'uikit/dist/js/uikit.js';
import '../../node_modules/uikit/dist/js/uikit.js';
import '../scss/style.scss';

import '@fortawesome/fontawesome-pro/js/all';

jQuery(document).ready(function ($) {

	/* ACTU LOAD MORE */
	$(function () {
		$(".actu").slice(0, 3).show();
		$("#loadMore").on('click', function (e) {
			e.preventDefault();
			$(".actu:hidden").slice(0, 3).slideDown();
			if ($(".actu:hidden").length == 0) {
				$("#loadMore").fadeOut('slow');
			}
			
		});
	});

	/* site header astra  */

	$(window).scroll(function () {
		$('#masthead.site-header').toggleClass('scrolled', $(window).scrollTop() > 30);

	});

	/******************************
     BOTTOM SCROLL TOP BUTTON
     ******************************/

	// declare variable
	var scrollTop = $('.back-to-top');

	$(window).scroll(function () {
		// declare variable
		var topPos = $(this).scrollTop();

		// if user scrolls down - show scroll to top button
		if (topPos > 100) {
			$(scrollTop).css('opacity', '1');
		} else {
			$(scrollTop).css('opacity', '0');
		}
	}); // scroll END

	//Click event to scroll to top
	$(scrollTop).click(function () {
		$('html, body').animate(
			{
				scrollTop: 0,
			},
			800
		);
		return false;
	}); // click() scroll top EMD
	/*******************************/
});
